import gql from "graphql-tag";

export default gql`mutation UpdateQuoteEmailQuote($id:Int!,$selectedEmails:[Int]!,$selectedRevisions:[Int]!) {
    updateQuoteEmailQuote(id:$id, selectedEmails:$selectedEmails, selectedRevisions:$selectedRevisions) {
        id
    }
  }`